import { render, staticRenderFns } from "./upcomingSessionList.vue?vue&type=template&id=36b0905f&"
import script from "./upcomingSessionList.vue?vue&type=script&lang=js&"
export * from "./upcomingSessionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports